"use client"

import VersionsTable from "@/components/versions/VersionsTable"
import { VersionsSchema } from "@/schemas/versions.schema";
import { getVersionsWithSubversions } from "@/services/versions.service";
import { useEffect, useState } from "react";
import { z } from "zod";

export default function VersionsPage() {
    const [currentVersions, setCurrentVersions] = useState<z.infer<typeof VersionsSchema>[]>([]);

    const setInitialVersions = async () => {
        const versions = await getVersionsWithSubversions();
        setCurrentVersions(versions);
    }

    useEffect(() => {
        if(currentVersions.length === 0){
            setInitialVersions();
        }
    });

    return (
        <VersionsTable versions={currentVersions}/>
    )
}